import { render, staticRenderFns } from "./FoldableIcon.vue?vue&type=template&id=dfa59608&scoped=true&"
import script from "./FoldableIcon.vue?vue&type=script&lang=js&"
export * from "./FoldableIcon.vue?vue&type=script&lang=js&"
import style0 from "./FoldableIcon.vue?vue&type=style&index=0&id=dfa59608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa59608",
  null
  
)

export default component.exports